import React from "react";

export const HamburgerIcon = ({ ...props }) => {
  return (
    <svg width={20} height={14} viewBox="0 0 20 14" fill="none" {...props}>
      <path
        d="M15 5H1M19 1H1M19 9H1M15 13H1"
        stroke="#214160"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
